import { FAQ_QUERYResult } from '@/__sanity_generated__/typegen'
import { FAQ } from '@/components/FAQ'
import { Layout } from '@/components/Layout'
import { FAQ_QUERY } from '@/groq/faq'
import { getClient } from '@/lib/sanity'
import { GetStaticProps } from 'next'
import { Text, View } from 'reshaped'

interface FAQPageProps {
  faq: FAQ_QUERYResult
}

function FAQPage({ faq }: FAQPageProps) {
  return (
    <Layout title="$ZORA Claim - FAQ">
      <View align="center" gap={8} paddingBottom={10}>
        <Text color="primary" variant="title-6">
          FAQ
        </Text>
        <FAQ faq={faq} />
      </View>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps<FAQPageProps> = async () => {
  const faq = await getClient().fetch<FAQ_QUERYResult>(FAQ_QUERY)
  return {
    props: { faq },
  }
}

export default FAQPage
